// composables/useTabulatorSettings.ts
import {TabulatorFull as Tabulator} from 'tabulator-tables';
export const useTabulatorSettings = () => {
  const PAGINATION_SIZE_KEY = 'tabulator-pagination-size';

  const isMobile = () => window.innerWidth <= 768;

  const getPaginationSize = () => {
    const saved = parseInt(localStorage.getItem(PAGINATION_SIZE_KEY) || '');
    return isNaN(saved) ? (isMobile() ? 5 : 20) : saved;
  };

  const setPaginationSize = (size: number) => {
    localStorage.setItem(PAGINATION_SIZE_KEY, size.toString());
  };

  const setupPaginationListener = (table: Tabulator) => {
    table.on('pageSizeChanged', (newSize: number) => {
      
      setPaginationSize(newSize);
    });
  };

  return {
    getPaginationSize,
    setPaginationSize,
    setupPaginationListener,
  };
};
